module.exports = __webpack_public_path__ + "img/prize-03.74d18c25.png";